import React, { useEffect, useState } from 'react';
import { Container, Row, Col, Card, Button, Image } from 'react-bootstrap';
import { Link } from "react-router-dom";
import Footer from "./footer";
import Header from "./header";
import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css'; // Add Font Awesome
import { studentdashboardcount, studentdetail, studentview, teacherview, workerdashboardcount, tokensave, teacherdashboardcount, stuacademicyearlist } from '../service/dashboard';
import { applyOneSignalIdentity } from '../service/onesignal';
import moment from 'moment';


const TrackingDashboard = () => {

    useEffect(() => {

        // Inside the Flutter WebView there is no web-push subscription, so the
        // token is usually absent — register anyway, because the response
        // carries the identity tags and those work without one. The native
        // shell registers its own OneSignal token separately.
        const rawToken = localStorage.getItem("notitoken") || "";
        const deviceToken = rawToken.replace(/^"|"$/g, ""); // strip JSON quotes if any

        const temp2 = new FormData();
        temp2.append("academy_id", localStorage.getItem("academy"));
        temp2.append("login_user_id", localStorage.getItem("UID"));
        temp2.append("role_id", localStorage.getItem("Role"));
        temp2.append("device_token", deviceToken);

        tokensave(temp2).then((response) => {
            if (response && response.status === true) {
                if (deviceToken) {
                    localStorage.setItem("notitoken", deviceToken);
                }
                applyOneSignalIdentity(response.data);
            }
        });


        listall()
    }, []);
    const [udet, setUdet] = useState("");
    const [spath, setSPath] = useState("");
    const [isTransport, setIsTransport] = useState(false);


    const [todayTimetable, setTodayTimetable] = useState([]);
    const [currentTime, setCurrentTime] = useState(new Date());
    const currentDayIndex = new Date().getDay();
    const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday'];
    const currentDay = days[currentDayIndex];
    const [tpath, setTPath] = useState("");
    const [edetail, setEDetail] = useState("");

    function listall() {
        setTodayTimetable([]);
        if (localStorage.getItem("Role") === "4") {
            const temp = new FormData();
            temp.append("user_id", localStorage.getItem("UID"));
            studentdashboardcount(temp).then((res) => {
                if (res.status === true) {
                    setSPath(res.data.path);
                    setUdet(res.data.students);
                    setTPath(res.data.tpath);
                    setIsTransport(res.data.students && res.data.students.resident_type == 3);
                    // if (res.data.timetable.length > 0) {
                    //     setTodayTimetable(res.data.timetable);
                    // }
                    if (res.data.timetable.length > 0) {
                        const currentDay = new Date().toLocaleDateString('en-US', { weekday: 'long' }); // e.g., "Thursday"

                        // Filter based on the current day
                        const filteredTimetable = res.data.timetable.filter(item => item.day === currentDay);

                        const updatedTimetable = filteredTimetable
                            .map((item) => {
                                return {
                                    ...item,
                                };
                            })
                            .sort((a, b) => Number(a.period) - Number(b.period));
                        setTodayTimetable(updatedTimetable);
                    }

                    studentdetail(res.data.students.id, moment(new Date()).format("YYYY-MM-DD"), moment(new Date()).format("YYYY-MM-DD")).then((res1) => {
                        if (res1.status === true) {
                            if (res1.data.examdetails.length > 0) {
                                setEDetail(res1.data.examdetails[0]);
                            }
                        }
                    });
                }
            })



        } else if (localStorage.getItem("Role") === "5") {
            teacherview(localStorage.getItem("UID")).then((res) => {
                if (res.status === true) {
                    setUdet(res.data.details);
                    setSPath(res.data.path);
                    setTPath(res.data.path);
                    setIsTransport(res.data.details && res.data.details.teacher_resident == 3);
                }
            })

            const tempyear = new FormData();
            tempyear.append("academy_id", localStorage.getItem("academy"));
            stuacademicyearlist(tempyear).then((yres) => {
                if (yres.status === true && yres.data.length > 0) {
                    const latestYear = [...yres.data].sort(
                        (a, b) => Number(b.id) - Number(a.id)
                    )[0].id;

                    const temp = new FormData();
                    temp.append("user_id", localStorage.getItem("UID"));
                    temp.append("year", latestYear);
                    teacherdashboardcount(temp).then((tres) => {
                        if (tres.status === true && tres.data.timetable.length > 0) {
                            const today = new Date().toLocaleDateString('en-US', { weekday: 'long' });
                            const updatedTimetable = tres.data.timetable
                                .filter(item => item.day === today)
                                .sort((a, b) => Number(a.period) - Number(b.period));
                            setTodayTimetable(updatedTimetable);
                        }
                    });
                }
            });
        } else if (localStorage.getItem("Role") === "6" || localStorage.getItem("Role") === "9") {
            // Worker (6) and Driver (9) both resolve through the workers table.
            const temp = new FormData();
            temp.append("user_id", localStorage.getItem("UID"));
            temp.append("role_id", localStorage.getItem("Role"));
            workerdashboardcount(temp).then((res) => {
                if (res?.status === true) {
                    setUdet(res.data.workers);
                    setSPath(res.data.path);
                }
            })
        }

    }
    const errorhandle = (ev) => {
        ev.target.src = require("../assets/images/placeholder.png");
        ev.target.onerror = null;
    }

    return (
        <div id="mainpage">
            <div className="maincontent">
                <Header />

                <Container>


                    <div className="top-bar mt-3">
                        <div className="morecontent-inner">
                            <img
                                // src={require("../assets/images/placeholder.png")}
                                src={
                                    (localStorage.getItem("Role") === "6" || localStorage.getItem("Role") === "9")
                                        ? (udet.worker_photo ? spath + udet.worker_photo : require("../assets/images/placeholder.png"))
                                        : (udet.photo ? spath + udet.photo : require("../assets/images/placeholder.png"))
                                }
                                alt="qrcode"
                                className="profileimg"
                                onError={errorhandle}
                            />
                        </div>
                        {/* <i className="fas fa-bars menu-icon"></i> */}
                        <span className="app-title">
                            {localStorage.getItem("Role") === "4" ? udet.student_name
                             : (localStorage.getItem("Role") === "6" || localStorage.getItem("Role") === "9") ? udet.worker_name
                             : udet.teacher_name}
                        </span>
                        {/* <span className="app-title">{udet.student_name}</span> */}
                        <div className="top-icons">
                            <span className="nidjamdatee">{udet.class_name} - {udet.section_name} </span>
                        </div>
                    </div>

                    <h5 className="mt-4">Welcome Back !
                    </h5>
                    <Row className="services-row mt-3">
                        <Col xs={3} className="service-icon text-center mb-3">
                            <Link to="/profile">
                                <Card className="icon-card py-3">
                                    <i className="fas fa-graduation-cap service-icon-inner"></i>
                                </Card>
                                <small className="d-block mt-1"> Profile</small>
                            </Link>
                        </Col>

                        <Col xs={3} className="service-icon text-center mb-3">
                            <Link to="/myattendance">
                                <Card className="icon-card py-3">
                                    <i className="fas fa-user-check service-icon-inner"></i>
                                </Card>
                                <small className="d-block mt-1">Attendance</small>
                            </Link>
                        </Col>

                        {(localStorage.getItem("Role") === "4" || localStorage.getItem("Role") === "5") &&
                            <Col xs={3} className="service-icon text-center mb-3">
                                <Link to="/timetable">
                                    <Card className="icon-card py-3">
                                        <i className="fas fa-calendar-alt service-icon-inner"></i>
                                    </Card>
                                    <small className="d-block mt-1">Timetable</small>
                                </Link>
                            </Col>
                        }

                        {(localStorage.getItem("Role") === "4" || localStorage.getItem("Role") === "5") &&
                            <Col xs={3} className="service-icon text-center mb-3">
                                <Link to="/homework">
                                    <Card className="icon-card py-3">
                                        <i className="fas fa-book service-icon-inner"></i>
                                    </Card>
                                    <small className="d-block mt-1">Homework</small>
                                </Link>
                            </Col>
                        }
                        {localStorage.getItem("Role") === "5" &&
                            <Col xs={3} className="service-icon text-center mb-3">
                                <Link to="/studentlist">
                                    <Card className="icon-card py-3">
                                        <i className="fas fa-users service-icon-inner"></i>
                                    </Card>
                                    <small className="d-block mt-1">Student List</small>
                                </Link>
                            </Col>
                        }
                        {localStorage.getItem("Role") === "5" &&
                            <Col xs={3} className="service-icon text-center mb-3">
                                <Link to="/studentattendance">
                                    <Card className="icon-card py-3">
                                        <i className="fas fa-pen-alt service-icon-inner"></i>
                                    </Card>
                                    <small className="d-block mt-1">Student Attendance</small>
                                </Link>
                            </Col>
                        }
                        {localStorage.getItem("Role") === "5" &&
                            <Col xs={3} className="service-icon text-center mb-3">
                                <Link to="/teacherlist">
                                    <Card className="icon-card py-3">
                                        <i className="fas fa-user service-icon-inner"></i>
                                    </Card>
                                    <small className="d-block mt-1">Teacher List</small>
                                </Link>
                            </Col>
                        }
                        {(localStorage.getItem("Role") === "5" || localStorage.getItem("Role") === "6" || localStorage.getItem("Role") === "9") &&
                            <Col xs={3} className="service-icon text-center mb-3">
                                <Link to="/payslip">
                                    <Card className="icon-card py-3">
                                        <i className="fas fa-file-invoice-dollar service-icon-inner"></i>
                                    </Card>
                                    <small className="d-block mt-1">Payslip</small>
                                </Link>
                            </Col>
                        }
                        {localStorage.getItem("Role") === "4" &&
                            <Col xs={3} className="service-icon text-center mb-3">
                                <Link to="/feessummary">
                                    <Card className="icon-card py-3">
                                        <i className="fas fa-receipt service-icon-inner"></i>
                                    </Card>
                                    <small className="d-block mt-1">Fees Summary</small>
                                </Link>
                            </Col>
                        }
                        {localStorage.getItem("Role") === "4" &&
                            <Col xs={3} className="service-icon text-center mb-3">
                                <Link to="/result">
                                    <Card className="icon-card py-3">
                                        <i className="fas fa-chart-line service-icon-inner"></i>
                                    </Card>
                                    <small className="d-block mt-1">Examination</small>
                                </Link>
                            </Col>
                        }
                        <Col xs={3} className="service-icon text-center mb-3">
                            <Link to="/leavedashboard">
                                <Card className="icon-card py-3">
                                    <i className="fas fa-calendar-minus service-icon-inner"></i>
                                </Card>
                                <small className="d-block mt-1">Leave</small>
                            </Link>
                        </Col>
                        <Col xs={3} className="service-icon text-center mb-3">
                            <Link to="/idcard">
                                <Card className="icon-card py-3">
                                    <i className="fas fa-calendar-minus service-icon-inner"></i>
                                </Card>
                                <small className="d-block mt-1">IDCard</small>
                            </Link>
                        </Col>
                        <Col xs={3} className="service-icon text-center mb-3">
                            <Link to="/complaint">
                                <Card className="icon-card py-3">
                                    <i className="fas fa-address-card service-icon-inner"></i>
                                </Card>
                                <small className="d-block mt-1">Complaint</small>
                            </Link>
                        </Col>
                          <Col xs={3} className="service-icon text-center mb-3">
                            <Link to="/events">
                                <Card className="icon-card py-3">
                                    <i className="fas fa-calendar-minus service-icon-inner"></i>
                                </Card>
                                <small className="d-block mt-1">Events</small>
                            </Link>
                        </Col>
                        {localStorage.getItem("Role") === "4" &&
                            <Col xs={3} className="service-icon text-center mb-3">
                                <Link to="/reportcard">
                                    <Card className="icon-card py-3">
                                        <i className="fas fa-address-card service-icon-inner"></i>
                                    </Card>
                                    <small className="d-block mt-1">Report Card</small>
                                </Link>
                            </Col>
                        }
                        <Col xs={3} className="service-icon text-center mb-3">
                            <Link to="/mycertificate">
                                <Card className="icon-card py-3">
                                    <i className="fas fa-certificate service-icon-inner"></i>
                                </Card>
                                <small className="d-block mt-1">My Certificate</small>
                            </Link>
                        </Col>
                        {isTransport && localStorage.getItem("Role") === "4" &&
                            <Col xs={3} className="service-icon text-center mb-3">
                                <Link to="/transportattendance">
                                    <Card className="icon-card py-3">
                                        <i className="fas fa-bus service-icon-inner"></i>
                                    </Card>
                                    <small className="d-block mt-1">Transport Attendance</small>
                                </Link>
                            </Col>
                        }
                        {isTransport && localStorage.getItem("Role") === "4" &&
                            <Col xs={3} className="service-icon text-center mb-3">
                                <Link to="/vehicletracking">
                                    <Card className="icon-card py-3">
                                        <i className="fas fa-map-marker-alt service-icon-inner"></i>
                                    </Card>
                                    <small className="d-block mt-1">Track Bus</small>
                                </Link>
                            </Col>
                        }
                        {localStorage.getItem("Role") === "5" &&
                            <Col xs={3} className="service-icon text-center mb-3">
                                <Link to="/transportattendance">
                                    <Card className="icon-card py-3">
                                        <i className="fas fa-bus service-icon-inner"></i>
                                    </Card>
                                    <small className="d-block mt-1">Transport Attendance</small>
                                </Link>
                            </Col>
                        }
                        {localStorage.getItem("Role") === "9" &&
                            <Col xs={3} className="service-icon text-center mb-3">
                                <Link to="/sharelocation">
                                    <Card className="icon-card py-3">
                                        <i className="fas fa-location-dot service-icon-inner"></i>
                                    </Card>
                                    <small className="d-block mt-1">Share Location</small>
                                </Link>
                            </Col>
                        }
                        {localStorage.getItem("Role") === "5" &&
                            <Col xs={3} className="service-icon text-center mb-3">
                                <Link to="/studentmarkenter">
                                    <Card className="icon-card py-3">
                                        <i className="fas fa-marker service-icon-inner"></i>
                                    </Card>
                                    <small className="d-block mt-1">Mark Entry</small>
                                </Link>
                            </Col>
                        }
                        {localStorage.getItem("Role") === "4" &&
                            <Col xs={3} className="service-icon text-center mb-3">
                                <Link to="/feereport">
                                    <Card className="icon-card py-3">
                                        <i className="fas fa-file-invoice-dollar service-icon-inner"></i>
                                    </Card>
                                    <small className="d-block mt-1">Fee Report</small>
                                </Link>
                            </Col>
                        }
                        {/* <Col xs={3} className="service-icon text-center mb-3">
                            <Link to="/transport">
                                <Card className="icon-card py-3">
                                    <i className="fas fa-bus service-icon-inner"></i>
                                </Card>
                                <small className="d-block mt-1">Transport</small>
                            </Link>
                        </Col>

                        <Col xs={3} className="service-icon text-center mb-3">
                            <Link to="/fees">
                                <Card className="icon-card py-3">
                                    <i className="fas fa-rupee-sign service-icon-inner"></i>
                                </Card>
                                <small className="d-block mt-1">Fees</small>
                            </Link>
                        </Col> */}
                    </Row>


                    {localStorage.getItem("Role") !== "9" && <>
                    <h5 className="mt-4">Upcoming Class</h5>
                    {todayTimetable.length === 0 && <p className="text-center text-danger">No Upcoming Class</p>

                    }
                    {todayTimetable.map((item, index) => {
                        return (
                            <Card className="event-card" key={index}>
                                <Row>
                                    <Col xs={3}>
                                        <div className="morecontent-inner">
                                            <img
                                                src={tpath + item.teacher_photo}
                                                alt="qrcode"
                                                className="profileimggg"
                                                onError={errorhandle}
                                            />
                                        </div>
                                    </Col>
                                    <Col className='upcommingclass'>
                                        <strong>{item.subject_name} ({item.from_time} - {item.to_time})</strong><br />
                                        {(item.class_name || item.section_name) &&
                                            <><small>{item.class_name}{item.section_name ? ` - ${item.section_name}` : ""}</small><br /></>
                                        }
                                        <small>{item.teacher_name}</small>
                                    </Col>
                                    <Col xs={3} className="text-end">
                                        <small className="event-date">{item.slot_name}</small>
                                    </Col>
                                </Row>
                            </Card>
                        )
                    })

                    }
                    </>}
                    {/* <Card className="event-card">
                        <Row>
                            <Col xs={3}>
                                <div className="morecontent-inner">
                                    <img
                                        src={require("../assets/images/placeholder.png")}
                                        alt="qrcode"
                                        className="profileimggg"
                                    />
                                </div>
                            </Col>
                            <Col className='upcommingclass'>
                                <strong>Tamil</strong><br />
                                <small>Rahul Kannan</small>
                            </Col>
                            <Col xs={3} className="text-end">
                                <small className="event-date">10:00 AM </small>
                            </Col>
                        </Row>
                    </Card>
                    <Card className="event-card">
                        <Row>
                            <Col xs={3}>
                                <div className="morecontent-inner">
                                    <img
                                        src={require("../assets/images/placeholder.png")}
                                        alt="qrcode"
                                        className="profileimggg"
                                    />
                                </div>
                            </Col>
                            <Col className='upcommingclass'>
                                <strong>Tamil</strong><br />
                                <small>Rahul Kannan</small>
                            </Col>
                            <Col xs={3} className="text-end">
                                <small className="event-date">10:00 AM </small>
                            </Col>
                        </Row>
                    </Card>

                    <Card className="event-card">
                        <Row>
                            <Col xs={3}>
                                <div className="morecontent-inner">
                                    <img
                                        src={require("../assets/images/placeholder.png")}
                                        alt="qrcode"
                                        className="profileimggg"
                                    />
                                </div>
                            </Col>
                            <Col className='upcommingclass'>
                                <strong>Tamil</strong><br />
                                <small>Rahul Kannan</small>
                            </Col>
                            <Col xs={3} className="text-end">
                                <small className="event-date">10:00 AM </small>
                            </Col>
                        </Row>
                    </Card> */}
                </Container>
                {edetail !== "" &&
                    <>
                        <hr />
                        <h5 className="mt-4">{edetail?.exam} - {edetail?.year}</h5>

                        <table className="table table-bordered align-middle text-center mt-2">
                            <thead className="table-light table-head-color">
                                <tr>
                                    <th>Subject</th>
                                    <th>Marks</th>
                                    <th>Result</th>
                                </tr>
                            </thead>
                            <tbody>
                                {edetail.details.map((detail, j) => {
                                    const obtainedMarks = (detail.theory_mark ?? 0) + (detail.practical_mark ?? 0);
                                    const totalMarks = (detail.exam_details_theory_mark ?? 0) + (detail.exam_details_pratical_mark ?? 0);

                                    return (
                                        <tr key={j}>
                                            <td>{detail.subject_name}</td>
                                            <td>
                                                {obtainedMarks}
                                            </td>
                                            <td><span className={obtainedMarks >= detail.pass_marks ? "result-pass text-white" : "result-fail text-white"}>{obtainedMarks >= detail.pass_marks ? "Pass" : "Fail"}</span></td>

                                        </tr>
                                    )
                                })}

                            </tbody>
                        </table>
                    </>
                }


                <div className="bottom-nav">
                    <Link to="/dashboard"><i className="fas fa-home"></i></Link>
                    {isTransport && localStorage.getItem("Role") === "4" &&
                        <Link to="/vehicletracking"><i className="fas fa-map-marker-alt"></i></Link>
                    }
                    <Link to="/profile"><i className="fas fa-user"></i></Link>
                </div>
            </div>
            <Footer />
        </div>
    );
};

export default TrackingDashboard;
